const headers = [
    // { text: 'សកម្មភាព', align: 'start', value: 'actions', sortable: false },
    {
        text: 'ល.រ',
        align: 'start',
        value: 'no',
    },
    { text: 'កម្មវីធី', value: 'app_id' },
    // { text: 'IP', value: 'public_ip' },
    { text: 'កាលបរិច្ឆេទ', value: 'date' },
    { text: 'គូប្រកួត', value: 'fight_no' },
    // { text: 'បុស្តិ៍លេខ', value: 'channel_type' },
    { text: 'បានចាក់', value: 'bet_name' },
    // { text: 'លិទ្ធផល', value: 'co_result.desc' },
    { text: 'សរុបប្រាក់ភ្នាល់', value: 'amount' },
    { text: 'Payout', value: 'payout' },
    { text: 'សរុបឈ្នះ/ចាញ់', value: 'amount_win' },
    { text: 'ប្រាក់សងត្រឡប់', value: 'cash' },
];

export default headers;